import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { EcReceiptItemList_ManagementSalesPage_Query } from "./query";

type Props = {
	queryVariables?: {
		hotelID: string;
		startDt: string;
		endDt: string;
	};
};

export const useSuspenseECReceiptListByStartAndEndDate = ({ queryVariables }: Props) => {
	const { data } = useCustomSuspenseQuery(
		EcReceiptItemList_ManagementSalesPage_Query,
		queryVariables ? { variables: queryVariables } : undefined,
		queryVariables === undefined, // skipToken = true
	);

	return {
		queryData: data?.ecReceiptItemList,
	};
};
